import { useContext } from 'react';
import ClientViewContext from 'src/contexts/ClientViewContext';

const useIsClientView = () => useContext(ClientViewContext);

export default useIsClientView;
